const globals = `
  * {
    box-sizing: border-box;
  }
`;

export default globals;
